import merge from "lodash/merge";
import { useTheme } from "../../components/ThemeProvider";
export const propsWithDefaults = (theme, component, currentProps) => {
    const defaultProps = theme.defaultProps?.[component];
    if (!defaultProps) {
        return currentProps;
    }
    if (!currentProps) {
        return currentProps;
    }
    if ("slotProps" in defaultProps && "slotProps" in currentProps) {
        return {
            ...defaultProps,
            ...currentProps,
            slotProps: merge({}, defaultProps.slotProps, currentProps.slotProps),
        };
    }
    return { ...defaultProps, ...currentProps };
};
export const useDefaultProps = ({ component, props, }) => propsWithDefaults(useTheme(), component, props);
//# sourceMappingURL=defaultProps.js.map